
const EMAIL = "lucinda@peaccollaboration.com";
const PHONE = "517-201-6197, extension 100";
export {EMAIL, PHONE}
